import { useState, type SyntheticEvent } from 'react';
import { ApiFailure, api } from '../api.ts';
import { Notice } from '../components/Notice.tsx';
import { copy } from '../copy/en-CA.ts';
import { useSession } from '../session.tsx';

export function SignInPage() {
  const { setUser } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [working, setWorking] = useState(false);

  const submit = async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setWorking(true);
    try {
      const { user } = await api.signIn(email, password);
      setUser(user);
    } catch (err) {
      setError(err instanceof ApiFailure ? err.message : copy.errors.unexpected);
    } finally {
      setWorking(false);
    }
  };

  return (
    <div className="signin-page">
      <div className="wordmark">
        <span className="wordmark-name">{copy.appName}</span>
        <span className="wordmark-sub">{copy.appSub}</span>
      </div>
      <form
        className="card signin-card"
        onSubmit={(e) => {
          void submit(e);
        }}
      >
        <div className="page-title">
          <h1>{copy.signIn.title}</h1>
          <p>{copy.signIn.intro}</p>
        </div>
        <div className="field">
          <label htmlFor="email">{copy.signIn.email}</label>
          <input id="email" className="input" type="email" autoComplete="username" required value={email} onChange={(e) => { setEmail(e.target.value); }} />
        </div>
        <div className="field">
          <label htmlFor="password">{copy.signIn.password}</label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => { setPassword(e.target.value); }}
          />
        </div>
        {error ? <Notice kind="error">{error}</Notice> : null}
        <button type="submit" className="btn primary" disabled={working}>
          {working ? copy.signIn.working : copy.signIn.submit}
        </button>
        <p className="muted small">{copy.signIn.forgot}</p>
      </form>
    </div>
  );
}
